module.exports = __webpack_public_path__ + "static/media/loginGuide1.758757ef.png";